import { apiHelper } from '@/utils'
import { API } from '@/constants'

const API_URL = API.BASE_URL + '/v1'

export const customerService = {
  getCustomers,
  updateCustomerLoginAccess,
  setCustomerPassword,
}

function buildParams(filter) {
  const params = {
    page: filter?.pageNumber,
    size: filter?.pageSize,
  }
  if (filter?.search) params.search = filter.search
  return params
}

export function getCustomers(filter) {
  return apiHelper(API_URL).get('/customers', { params: buildParams(filter) })
}

// Lock (false) / unlock (true) a customer's login.
export function updateCustomerLoginAccess(uuid, isAllowLogin) {
  return apiHelper(API_URL).patch(`/customers/${uuid}/login-access`, {
    is_allow_login: isAllowLogin,
  })
}

// Public — completes the emailed set-password link (also verifies the account).
export function setCustomerPassword({ email, token, password, passwordConfirmation }) {
  return apiHelper(API_URL).post('/customer/auth/set-password', {
    email,
    token,
    password,
    password_confirmation: passwordConfirmation,
  })
}
